/**
 * Extract a patient's gender from a visit/assessment API response.
 *
 * The legacy CRA dashboard hits two response shapes:
 *  - `/dashboard/visits/{id}` (RPC `api2_get_visit`) → `gender` lives at the
 *    top level of `res.data`.
 *  - `/dashboard/patient/active-visit/{id}` (proxy with Spring parity) →
 *    `gender` lives under `res.data.patient.gender`.
 *
 * Returns the top-level value when present, falling back to the nested
 * `patient.gender`. Returns `null` if neither is set so callers can guard
 * with a truthiness check before seeding state.
 */
export function extractPatientGender(data) {
  if (!data) return null;
  return data.gender || data.patient?.gender || null;
}
